import { __rest } from "tslib";
import React from 'react';
import Text from '../text';
import Slot from '../slot';
import { container, details, input, label } from './input-combo.css';
import { cn, generateId, isFunction } from '~/utils';
const INPUT_COMBO_NAME = 'vulcanui-input-combo';
function InputCombo({ children, description, label }) {
    const htmlFor = React.useRef(generateId());
    return (React.createElement("div", { className: cn(INPUT_COMBO_NAME, container) },
        React.createElement("div", { className: cn(details) },
            !!label && (React.createElement(Label, { title: label, htmlFor: htmlFor.current }, label)),
            !!description && (React.createElement(Description, { title: description, maxLines: 2 }, description))),
        React.createElement("div", { className: cn(input) }, isFunction(children) ? (children({ id: htmlFor.current })) : (React.createElement(Slot, { id: htmlFor.current }, children)))));
}
InputCombo.displayName = 'InputCombo';
InputCombo.toString = () => `.${INPUT_COMBO_NAME}`;
export function Label(_a) {
    var { children, htmlFor, title } = _a, restProps = __rest(_a, ["children", "htmlFor", "title"]);
    return (React.createElement(Text, Object.assign({ as: "label", weight: "bold", maxLines: 1, color: "default-800", className: cn(`${INPUT_COMBO_NAME}-label`, label), htmlFor: htmlFor, title: title }, restProps), children));
}
Label.displayName = 'InputCombo.Label';
Label.toString = () => `.${INPUT_COMBO_NAME}-label`;
export function Description(_a) {
    var { children, maxLines = 2, title } = _a, restProps = __rest(_a, ["children", "maxLines", "title"]);
    return (React.createElement(Text, Object.assign({ color: "default-400", as: "span", weight: "light", className: cn(`${INPUT_COMBO_NAME}-description`), maxLines: maxLines, title: title }, restProps), children));
}
Description.displayName = 'InputCombo.Description';
Description.toString = () => `.${INPUT_COMBO_NAME}-description`;
InputCombo.Label = Label;
InputCombo.Description = Description;
export default InputCombo;
//# sourceMappingURL=input-combo.js.map